import 'COMMON';
import { svgSpriteLoader } from 'Lib/svg-sprite-loader/svg-sprite-loader';
import 'Bem/site/books-slider/books-slider';
import 'Bem/site/book/book';
import 'Bem/site/tabs/tabs';
import { oLike } from 'Lib/like/like';
import 'Bem/site/buy-now/buy-now';

oLike.init('.js-book-like, .js-book-basket-like');

svgSpriteLoader('/site/basket/svg/sprite.svg?v=20180320');